export interface Movie {
  id: string;
  title: string;
  cover: string;
  banner?: string;
  type: 'movie' | 'tv';
  genres: string[];
  region: string;
  year: number;
  rating: number;
  director: string;
  actors: string[];
  duration?: string;
  episodes?: number;
  updatedTo?: string;
  updateTime: string;
  summary: string;
  isHot?: boolean;
  isFeatured?: boolean;
}

export const genreOptions = [
  '全部',
  '动作',
  '爱情',
  '科幻',
  '喜剧',
  '悬疑',
  '剧情',
  '古装',
  '犯罪',
  '奇幻',
  '青春',
  '武侠',
  '冒险',
];

export const regionOptions = ['全部', '内地', '香港', '台湾', '美国', '韩国', '日本', '英国'];

export const yearOptions = ['全部', '2026', '2025', '2024', '2023', '更早'];

export const sortOptions = [
  { key: 'latest', label: '按更新时间' },
  { key: 'rating', label: '按评分' },
  { key: 'hot', label: '按热度' },
];

export const movies: Movie[] = [
  {
    id: 'm1',
    title: '星际远征',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20sci-fi%20movie%20poster%2C%20deep%20space%20station%20silhouette%20against%20a%20giant%20crimson%20planet%2C%20dramatic%20rim%20lighting%2C%20charcoal%20and%20red%20color%20palette%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-m1&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Widescreen%20cinematic%20space%20epic%20scene%2C%20fleet%20of%20starships%20before%20a%20glowing%20red%20nebula%2C%20moody%20dark%20atmosphere%20with%20crimson%20accents%2C%20stylized%20digital%20artwork%2C%20no%20text&width=1600&height=900&seq=htv-banner-m1&orientation=landscape',
    type: 'movie',
    genres: ['科幻', '冒险'],
    region: '美国',
    year: 2026,
    rating: 8.8,
    director: '陈默',
    actors: ['林正轩', '苏晚', '周与安', 'K. Miller'],
    duration: '156分钟',
    updateTime: '2026-10-11',
    summary:
      '当地球资源濒临枯竭，一支由多国精英组成的远征舰队踏上前往半人马座的征途。未知的宇宙深空、神秘的引力异常，以及船员之间逐渐显露的秘密，让这场远征远比想象中凶险。',
    isHot: true,
    isFeatured: true,
  },
  {
    id: 'm2',
    title: '暗夜行者',
    cover:
      'https://readdy.ai/api/search-image?query=Noir%20vertical%20action%20crime%20movie%20poster%2C%20lone%20figure%20in%20a%20rain%20soaked%20neon%20alley%2C%20warm%20orange%20street%20light%20and%20deep%20shadow%2C%20gritty%20urban%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-m2&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Widescreen%20noir%20city%20night%20scene%2C%20rain%20slick%20streets%20with%20orange%20glow%20and%20long%20shadows%2C%20moody%20crime%20thriller%20atmosphere%2C%20stylized%20digital%20artwork%2C%20no%20text&width=1600&height=900&seq=htv-banner-m2&orientation=landscape',
    type: 'movie',
    genres: ['动作', '犯罪'],
    region: '香港',
    year: 2025,
    rating: 8.2,
    director: '麦兆辉',
    actors: ['古天乐', '刘青云', '倪妮', '姜皓文'],
    duration: '128分钟',
    updateTime: '2026-10-10',
    summary:
      '一名游走于黑白两道之间的卧底警探，在一次交易中身份险些暴露。为了洗清嫌疑，他必须在昔日兄弟与正义之间做出最后的抉择。',
    isHot: true,
    isFeatured: true,
  },
  {
    id: 'm3',
    title: '时光信笺',
    cover:
      'https://readdy.ai/api/search-image?query=Romantic%20vertical%20movie%20poster%2C%20two%20figures%20on%20a%20misty%20pier%20at%20golden%20hour%2C%20soft%20warm%20amber%20light%2C%20nostalgic%20melancholy%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-m3&orientation=portrait',
    type: 'movie',
    genres: ['爱情', '剧情'],
    region: '内地',
    year: 2025,
    rating: 8.6,
    director: '许安然',
    actors: ['周冬雨', '彭昱畅', '张子枫'],
    duration: '118分钟',
    updateTime: '2026-10-09',
    summary:
      '一封迟到十年的信，让两条早已走向不同人生的人重新有了交集。关于遗憾、成长与重逢，一部温柔而克制的爱情电影。',
    isFeatured: true,
  },
  {
    id: 'm4',
    title: '山海秘闻',
    cover:
      'https://readdy.ai/api/search-image?query=Fantasy%20vertical%20movie%20poster%2C%20mystic%20mountain%20peaks%20with%20floating%20islands%20and%20ancient%20beasts%2C%20deep%20red%20and%20jade%20tones%2C%20epic%20mythical%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-m4&orientation=portrait',
    type: 'movie',
    genres: ['奇幻', '冒险'],
    region: '内地',
    year: 2026,
    rating: 8.4,
    director: '路遥',
    actors: ['易烊千玺', '文淇', '王传君'],
    duration: '142分钟',
    updateTime: '2026-10-08',
    summary:
      '传说《山海经》中的异兽从未真正消失。一位年轻的地理绘图师误入秘境，必须在古老预言应验之前找回失落的图卷。',
    isHot: true,
  },
  {
    id: 'm5',
    title: '归途列车',
    cover:
      'https://readdy.ai/api/search-image?query=Quiet%20drama%20vertical%20movie%20poster%2C%20a%20lone%20traveler%20silhouette%20on%20an%20empty%20train%20platform%20at%20dusk%2C%20cool%20grey%20with%20a%20warm%20red%20lamp%20accent%2C%20contemplative%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-m5&orientation=portrait',
    type: 'movie',
    genres: ['剧情'],
    region: '内地',
    year: 2024,
    rating: 9.0,
    director: '贾樟柯',
    actors: ['张译', '伊能静', '黄尧'],
    duration: '134分钟',
    updateTime: '2026-10-07',
    summary:
      '一趟横穿大陆的列车，串联起六个普通人的命运片段。在缓慢的行进中，故乡与远方、告别与归来交织成一幅当代生活图景。',
  },
  {
    id: 'm6',
    title: '爆笑一家亲',
    cover:
      'https://readdy.ai/api/search-image?query=Bright%20comedic%20vertical%20movie%20poster%2C%20a%20chaotic%20happy%20family%20in%20a%20warm%20cluttered%20living%20room%2C%20vivid%20orange%20and%20red%20tones%2C%20playful%20festive%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-m6&orientation=portrait',
    type: 'movie',
    genres: ['喜剧'],
    region: '内地',
    year: 2025,
    rating: 7.9,
    director: '沈腾',
    actors: ['马丽', '常远', '艾伦'],
    duration: '108分钟',
    updateTime: '2026-10-06',
    summary:
      '一场突如其来的家庭聚会，让三代同堂的一家人在一天之内闹出了无数笑话。笑中带暖，一部适合全家观看的贺岁喜剧。',
  },
  {
    id: 'm7',
    title: '深渊回响',
    cover:
      'https://readdy.ai/api/search-image?query=Suspense%20thriller%20vertical%20movie%20poster%2C%20a%20faint%20figure%20descending%20into%20a%20dark%20narrow%20submarine%20corridor%2C%20cold%20teal%20shadow%20with%20a%20single%20red%20emergency%20light%2C%20tense%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-m7&orientation=portrait',
    type: 'movie',
    genres: ['悬疑'],
    region: '韩国',
    year: 2025,
    rating: 8.5,
    director: '奉俊昊',
    actors: ['李政宰', '裴斗娜', '金泰梨'],
    duration: '124分钟',
    updateTime: '2026-10-05',
    summary:
      '深海科研站突然与外界失联，唯一的幸存者带回一段无法解释的录音。真相正随着下潜的深度，一层层被揭开。',
    isHot: true,
  },
  {
    id: 'm8',
    title: '长安月下',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20period%20vertical%20movie%20poster%2C%20a%20figure%20in%20flowing%20hanfu%20beneath%20a%20full%20moon%20over%20ancient%20palace%20eaves%2C%20deep%20red%20lanterns%20and%20gold%20accents%2C%20romantic%20classical%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-m8&orientation=portrait',
    type: 'movie',
    genres: ['古装', '爱情'],
    region: '内地',
    year: 2024,
    rating: 8.3,
    director: '李少红',
    actors: ['刘亦菲', '陈晓', '王凯'],
    duration: '132分钟',
    updateTime: '2026-10-04',
    summary:
      '盛唐长安，一位才情出众的乐师与一位身份成谜的少女因一曲相识。繁华背后暗流涌动，爱情与家国在月色下悄然碰撞。',
  },
  {
    id: 'm9',
    title: '极速边缘',
    cover:
      'https://readdy.ai/api/search-image?query=High%20energy%20action%20vertical%20movie%20poster%2C%20a%20sports%20car%20drifting%20through%20orange%20light%20trails%20on%20a%20night%20highway%2C%20dynamic%20motion%20blur%2C%20red%20and%20amber%20palette%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-m9&orientation=portrait',
    type: 'movie',
    genres: ['动作'],
    region: '美国',
    year: 2026,
    rating: 8.1,
    director: 'J. Carter',
    actors: ['T. Reyes', 'M. Cole', 'A. Brooks'],
    duration: '121分钟',
    updateTime: '2026-10-03',
    summary:
      '地下赛车圈传奇车手被迫重返赛道，为救回被绑架的弟弟，他必须在一场生死时速的终极对决中赢下一切。',
    isHot: true,
  },
  {
    id: 'm10',
    title: '雪岭孤狼',
    cover:
      'https://readdy.ai/api/search-image?query=Survival%20adventure%20vertical%20movie%20poster%2C%20a%20lone%20mountaineer%20silhouette%20on%20a%20snow%20covered%20ridge%2C%20cold%20blue%20grey%20tones%20with%20a%20warm%20red%20jacket%20accent%2C%20stark%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-m10&orientation=portrait',
    type: 'movie',
    genres: ['冒险', '剧情'],
    region: '英国',
    year: 2024,
    rating: 7.8,
    director: 'R. Hall',
    actors: ['E. Fisher', 'N. Wood'],
    duration: '115分钟',
    updateTime: '2026-10-02',
    summary:
      '一场突如其来的雪崩将登山者困在无名雪岭。在极端低温与孤独中，他必须战胜的不只是自然，还有自己的过去。',
  },
  {
    id: 'm11',
    title: '星河恋曲',
    cover:
      'https://readdy.ai/api/search-image?query=Dreamy%20romance%20vertical%20movie%20poster%2C%20two%20lovers%20reaching%20toward%20each%20other%20under%20a%20starry%20sky%20with%20warm%20orange%20shooting%20stars%2C%20soft%20glow%2C%20sentimental%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-m11&orientation=portrait',
    type: 'movie',
    genres: ['爱情', '科幻'],
    region: '韩国',
    year: 2025,
    rating: 8.0,
    director: '朴赞郁',
    actors: ['IU', '朴宝剑', '金高银'],
    duration: '126分钟',
    updateTime: '2026-10-01',
    summary:
      '一位天文台研究员通过一台老旧仪器收到来自未来的讯号。相隔十六年的两个人，用星光谱写了一段跨越时空的恋曲。',
  },
  {
    id: 'm12',
    title: '无声证词',
    cover:
      'https://readdy.ai/api/search-image?query=Crime%20drama%20vertical%20movie%20poster%2C%20a%20courtroom%20silhouette%20with%20dusty%20light%20rays%20and%20a%20stack%20of%20case%20files%2C%20muted%20grey%20with%20crimson%20seal%20accent%2C%20serious%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-m12&orientation=portrait',
    type: 'movie',
    genres: ['犯罪', '悬疑'],
    region: '内地',
    year: 2026,
    rating: 8.7,
    director: '曹保平',
    actors: ['段奕宏', '周迅', '祖峰'],
    duration: '130分钟',
    updateTime: '2026-09-30',
    summary:
      '一桩尘封十二年的悬案因一段无声监控重新被翻出。年轻检察官与退休法医联手追查，发现证词之下藏着更深的沉默。',
    isHot: true,
  },
  {
    id: 't1',
    title: '江湖笔录',
    cover:
      'https://readdy.ai/api/search-image?query=Wuxia%20vertical%20series%20poster%2C%20a%20swordsman%20in%20flowing%20robes%20standing%20on%20a%20bamboo%20forest%20path%2C%20misty%20green%20with%20crimson%20sash%20accent%2C%20heroic%20ancient%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-t1&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Widescreen%20wuxia%20scene%2C%20misty%20bamboo%20forest%20with%20a%20swordsman%20silhouette%2C%20drifting%20petals%20and%20crimson%20light%2C%20moody%20cinematic%20atmosphere%2C%20stylized%20digital%20artwork%2C%20no%20text&width=1600&height=900&seq=htv-banner-t1&orientation=landscape',
    type: 'tv',
    genres: ['武侠', '古装'],
    region: '内地',
    year: 2026,
    rating: 9.2,
    director: '杨文军',
    actors: ['成毅', '张凌赫', '李沁'],
    episodes: 40,
    updatedTo: '更新至第32集',
    updateTime: '2026-10-12',
    summary:
      '一本记载江湖秘辛的《笔录》重现人间，引起各方势力争夺。初入江湖的少年剑客卷入其中，在恩怨情仇中逐渐成长为一代大侠。',
    isHot: true,
    isFeatured: true,
  },
  {
    id: 't2',
    title: '都市浮生记',
    cover:
      'https://readdy.ai/api/search-image?query=Urban%20drama%20vertical%20series%20poster%2C%20a%20modern%20city%20skyline%20at%20dusk%20with%20warm%20windows%20and%20a%20lone%20walking%20figure%2C%20amber%20and%20charcoal%20tones%2C%20reflective%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-t2&orientation=portrait',
    type: 'tv',
    genres: ['剧情', '爱情'],
    region: '内地',
    year: 2025,
    rating: 8.4,
    director: '汪俊',
    actors: ['雷佳音', '袁泉', '宋佳'],
    episodes: 36,
    updatedTo: '全36集',
    updateTime: '2026-10-11',
    summary:
      '四个在大城市打拼的年轻人，合租在同一间老公寓里。工作、情感、理想与现实，在他们彼此交织的生活中缓缓展开。',
  },
  {
    id: 't3',
    title: '刑侦档案',
    cover:
      'https://readdy.ai/api/search-image?query=Crime%20investigation%20vertical%20series%20poster%2C%20a%20detective%20silhouette%20before%20a%20case%20board%20covered%20in%20photos%20and%20red%20threads%2C%20moody%20dark%20tones%20with%20crimson%20accent%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-t3&orientation=portrait',
    type: 'tv',
    genres: ['犯罪', '悬疑'],
    region: '内地',
    year: 2026,
    rating: 8.9,
    director: '五百',
    actors: ['张颂文', '白宇', '谭卓'],
    episodes: 30,
    updatedTo: '更新至第18集',
    updateTime: '2026-10-12',
    summary:
      '一支重案组警队，用冷静而执着的推理破解一桩桩疑难案件。每一个档案背后，都是人心深处的欲望与救赎。',
    isHot: true,
  },
  {
    id: 't4',
    title: '长夜将明',
    cover:
      'https://readdy.ai/api/search-image?query=Period%20drama%20vertical%20series%20poster%2C%20a%20figure%20holding%20a%20lantern%20in%20a%20foggy%20old%20town%20street%20at%20dawn%2C%20muted%20grey%20with%20warm%20amber%20light%2C%20hopeful%20melancholy%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-t4&orientation=portrait',
    type: 'tv',
    genres: ['剧情'],
    region: '内地',
    year: 2024,
    rating: 9.1,
    director: '孔笙',
    actors: ['王凯', '杨紫', '刘奕君'],
    episodes: 45,
    updatedTo: '全45集',
    updateTime: '2026-10-09',
    summary:
      '动荡年代里，一个小镇青年的成长史。在时代洪流与个人选择之间，他一步步走向属于自己的黎明。',
  },
  {
    id: 't5',
    title: '王庭风云',
    cover:
      'https://readdy.ai/api/search-image?query=Historical%20palace%20vertical%20series%20poster%2C%20an%20emperor%20silhouette%20on%20a%20vast%20throne%20hall%2C%20deep%20red%20curtains%20and%20gold%20light%2C%20grand%20scheming%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-t5&orientation=portrait',
    type: 'tv',
    genres: ['古装', '剧情'],
    region: '内地',
    year: 2025,
    rating: 8.8,
    director: '郑晓龙',
    actors: ['陈道明', '胡歌', '刘涛'],
    episodes: 50,
    updatedTo: '全50集',
    updateTime: '2026-10-08',
    summary:
      '王朝更迭之际，朝堂之上暗流汹涌。一位出身寒微的谋士被卷入权力漩涡，在权谋与人心中寻找立足之地。',
    isHot: true,
  },
  {
    id: 't6',
    title: '青春协奏曲',
    cover:
      'https://readdy.ai/api/search-image?query=Youth%20school%20vertical%20series%20poster%2C%20a%20group%20of%20teenagers%20on%20a%20sunlit%20campus%20rooftop%2C%20bright%20warm%20tones%20with%20orange%20sun%20flare%2C%20energetic%20nostalgic%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-t6&orientation=portrait',
    type: 'tv',
    genres: ['青春', '爱情'],
    region: '内地',
    year: 2026,
    rating: 7.9,
    director: '郭帆',
    actors: ['赵今麦', '张新成', '田曦薇'],
    episodes: 24,
    updatedTo: '更新至第10集',
    updateTime: '2026-10-12',
    summary:
      '一所艺术高中的四个少年，因为一场校园音乐比赛走到一起。关于梦想、友情与初恋的成长故事，在琴声里缓缓流淌。',
  },
  {
    id: 't7',
    title: '迷雾侦探社',
    cover:
      'https://readdy.ai/api/search-image?query=Mystery%20detective%20vertical%20series%20poster%2C%20a%20foggy%20japanese%20alley%20with%20a%20magnifying%20glass%20and%20glowing%20shop%20sign%2C%20teal%20shadow%20with%20warm%20orange%20lamp%2C%20curious%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-t7&orientation=portrait',
    type: 'tv',
    genres: ['悬疑', '剧情'],
    region: '日本',
    year: 2025,
    rating: 8.6,
    director: '是枝裕和',
    actors: ['菅田将晖', '长泽雅美', '桥本环奈'],
    episodes: 12,
    updatedTo: '全12集',
    updateTime: '2026-10-05',
    summary:
      '一家藏在小巷深处的侦探社，接收着城市里最离奇的委托。每解开一个谜题，老板就离自己失去的记忆更近一步。',
  },
  {
    id: 't8',
    title: '医者仁心',
    cover:
      'https://readdy.ai/api/search-image?query=Medical%20drama%20vertical%20series%20poster%2C%20a%20doctor%20in%20scrubs%20under%20cool%20hospital%20lights%20with%20warm%20red%20accent%2C%20clean%20clinical%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-t8&orientation=portrait',
    type: 'tv',
    genres: ['剧情'],
    region: '内地',
    year: 2025,
    rating: 8.7,
    director: '张黎',
    actors: ['靳东', '马伊琍', '王阳'],
    episodes: 40,
    updatedTo: '全40集',
    updateTime: '2026-10-04',
    summary:
      '急诊科医生们在高强度的工作中与时间赛跑。每一场抢救都是对生命的尊重，也是对自己信念的拷问。',
  },
  {
    id: 't9',
    title: '幻境奇缘',
    cover:
      'https://readdy.ai/api/search-image?query=Fantasy%20romance%20vertical%20series%20poster%2C%20a%20pair%20of%20figures%20before%20a%20magical%20portal%20of%20glowing%20orange%20runes%2C%20ethereal%20warm%20light%2C%20enchanting%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-t9&orientation=portrait',
    type: 'tv',
    genres: ['奇幻', '爱情'],
    region: '韩国',
    year: 2026,
    rating: 8.3,
    director: '金恩淑',
    actors: ['金秀贤', '韩素希', '朴叙俊'],
    episodes: 16,
    updatedTo: '更新至第14集',
    updateTime: '2026-10-10',
    summary:
      '平凡女孩意外穿入一本古老的奇幻小说世界，成为扭转剧情的关键人物。她必须在结局到来前，改写属于自己的命运。',
    isHot: true,
  },
  {
    id: 't10',
    title: '热血篮球场',
    cover:
      'https://readdy.ai/api/search-image?query=Sports%20youth%20vertical%20series%20poster%2C%20a%20basketball%20slam%20dunk%20silhouette%20in%20a%20packed%20gym%2C%20energetic%20orange%20and%20red%20lighting%2C%20dynamic%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-t10&orientation=portrait',
    type: 'tv',
    genres: ['青春', '动作'],
    region: '内地',
    year: 2024,
    rating: 8.2,
    director: '陈可辛',
    actors: ['王俊凯', '张宁', '刘昊然'],
    episodes: 30,
    updatedTo: '全30集',
    updateTime: '2026-10-02',
    summary:
      '一支濒临解散的高中篮球队，在倔强教练的带领下重新集结。从垫底到逆袭，他们用汗水证明青春不该认输。',
  },
  {
    id: 't11',
    title: '商贸风云',
    cover:
      'https://readdy.ai/api/search-image?query=Business%20drama%20vertical%20series%20poster%2C%20a%20city%20skyline%20reflected%20in%20a%20glass%20office%20tower%2C%20cool%20grey%20with%20crimson%20accent%2C%20ambitious%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-t11&orientation=portrait',
    type: 'tv',
    genres: ['剧情', '悬疑'],
    region: '香港',
    year: 2025,
    rating: 8.5,
    director: '韦家辉',
    actors: ['郭富城', '佘诗曼', '林峯'],
    episodes: 35,
    updatedTo: '全35集',
    updateTime: '2026-10-01',
    summary:
      '一场家族企业的继承之争，牵出数十年的商业恩怨。资本与情感博弈之下，没有人能全身而退。',
  },
  {
    id: 't12',
    title: '幽宅迷踪',
    cover:
      'https://readdy.ai/api/search-image?query=Horror%20mystery%20vertical%20series%20poster%2C%20a%20decaying%20gothic%20mansion%20with%20a%20single%20glowing%20window%2C%20cold%20dark%20tones%20with%20faint%20red%20glow%2C%20eerie%20mood%2C%20stylized%20illustration%2C%20no%20text&width=400&height=600&seq=htv-poster-t12&orientation=portrait',
    type: 'tv',
    genres: ['悬疑', '奇幻'],
    region: '美国',
    year: 2026,
    rating: 8.0,
    director: 'M. Flynn',
    actors: ['S. Clark', 'D. Novak', 'R. Stone'],
    episodes: 10,
    updatedTo: '更新至第6集',
    updateTime: '2026-10-12',
    summary:
      '一家人搬进郊外的百年老宅，接二连三的怪事让他们意识到，这座房子的秘密远比传闻更加可怕。',
  },
];

// helpers live in src/utils/media.ts



